module.exports = __webpack_public_path__ + "img/excel-format-screen-shot-2.efc6fec3.png";